import { render, staticRenderFns } from "./editBigScreenTitle.vue?vue&type=template&id=45b97090&scoped=true&"
import script from "./editBigScreenTitle.vue?vue&type=script&lang=js&"
export * from "./editBigScreenTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b97090",
  null
  
)

export default component.exports